export default {
    'reminder-type': 'reminder type',
    'delete-message-reminder-type': 'Are you sure you want to delete this reminder type?'
}